const profile = {
  moduleTitle: "الملف الشخصي",
  nav: {
    account: "حسابي",
    profile: "الملف الشخصي",
    security: "الأمان والخصوصية",
  },
  view: {
    subtitle: "التفاصيل والمعلومات الأساسية للملف",
    edit: "تعديل",
    profileSection: "الملف الشخصي",
    detailsSection: "تفاصيل الحساب",
    company: "اسم المؤسسة",
    fullName: "الاسم الثلاثي",
    email: "البريد الإلكتروني",
    phoneNumber: "رقم الهاتف",
    username: "اسم المستخدم",
    lastPasswordChange: "آخر تغيير لكلمة المرور",
    neverChanged: "لم يتم التغيير بعد",
    twoFactor: "تفعيل المصادقة الثنائية (2FA)",
    loading: "جارٍ تحميل الملف الشخصي",
    error: "تعذّر تحميل الملف الشخصي.",
  },
  edit: {
    title: "تعديل الملف الشخصي",
    subtitle: "التفاصيل والمعلومات الأساسية للملف",
    back: "رجوع",
    pictureSection: "صورة الملف الشخصي",
    upload: "تحميل صورة",
    remove: "إزالة الصورة",
    pictureHint: "JPG أو JPEG أو PNG، بحد أقصى 20MB",
    invalidPicture:
      "يرجى تحميل صورة صالحة (JPG أو JPEG أو PNG) لا يتجاوز حجمها الحد الأقصى المسموح به.",
    company: "اسم المؤسسة",
    nameAr: "الاسم (AR)",
    nameEn: "الاسم (EN)",
    username: "اسم المستخدم",
    email: "البريد الإلكتروني",
    phoneNumber: "رقم الهاتف",
    countrySelectAriaLabel: "اختر رمز الدولة",
    countries: {
      ksa: "المملكة العربية السعودية",
      egypt: "جمهورية مصر العربية",
      uae: "الإمارات العربية المتحدة",
      jordan: "المملكة الأردنية الهاشمية",
    },
    cancel: "إلغاء",
    save: "حفظ التعديلات",
    saveSuccess: "تم تحديث الملف الشخصي بنجاح.",
    removeDialog: {
      title: "إزالة الصورة",
      message: "هل أنت متأكد أنك تريد إزالة صورة ملفك الشخصي؟",
      confirm: "إزالة",
      cancel: "إلغاء",
      close: "إغلاق",
    },
    unsavedChanges: {
      title: "تغييرات غير محفوظة",
      message: "لديك تغييرات غير محفوظة. هل أنت متأكد أنك تريد المغادرة؟",
      stay: "البقاء",
      leave: "مغادرة",
      close: "إغلاق",
    },
  },
  twoFactor: {
    enableTitle: "تفعيل المصادقة الثنائية",
    description: "أدخل رمز التحقق المكوّن من 6 أرقام المرسل إلى {{email}}",
    codeLabel: "رمز التحقق",
    codeRequired: "أدخل رمز التحقق المكوّن من 6 أرقام.",
    invalidCode: "رمز التحقق غير صحيح.",
    codeExpired: "انتهت صلاحية رمز التحقق. اطلب رمزًا جديدًا.",
    attemptsExceeded:
      "لقد وصلت إلى الحد الأقصى من المحاولات. يرجى طلب رمز تحقق جديد.",
    disableDialog: {
      title: "تعطيل المصادقة الثنائية",
      message: "هل أنت متأكد من أنك تريد تعطيل المصادقة الثنائية؟",
      note: "تعطيل المصادقة الثنائية سوف يقلل من مستوى أمان حسابك، وسيكون الحساب محميًا بكلمة المرور فقط.",
      confirm: "تعطيل",
      cancel: "إلغاء",
      close: "إغلاق",
    },
    confirm: "تأكيد",
    verifying: "جارٍ التحقق...",
    verified: "تم التحقق بنجاح",
    close: "إغلاق",
    expiresIn: "تنتهي صلاحية الرمز خلال",
    didNotReceive: "لم يصلك الرمز؟",
    resend: "أعد إرسال الرمز",
    resent: "تم إرسال رمز جديد.",
    enabledSuccess: "تم تفعيل المصادقة الثنائية بنجاح.",
    disabledSuccess: "تم تعطيل المصادقة الثنائية بنجاح.",
  },
  security: {
    title: "تغيير كلمة المرور وإعدادات الأمان",
    subtitle: "إدارة كلمة المرور، سياسات الأمان وتتبع الجلسات النشطة",
    sectionTitle: "تغيير كلمة المرور",
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmPassword: "تأكيد كلمة المرور الجديدة",
    currentPasswordRequired: "كلمة المرور الحالية مطلوبة.",
    save: "حفظ كلمة المرور",
    rulesTitle:
      "يجب أن تحتوي كلمة المرور الجديدة الخاصة بك على المعايير التالية لحماية حسابك:",
    success: "تم تغيير كلمة المرور بنجاح.",
    successSignedOut:
      "تم تغيير كلمة المرور بنجاح. يرجى تسجيل الدخول مرة أخرى.",
    incorrectCurrentPassword: "كلمة المرور الحالية غير صحيحة.",
    sameAsCurrent: "يجب أن تختلف كلمة المرور الجديدة عن الحالية.",
  },
};

export default profile;
